import React from "react";

const content = (
  <>
    <p>My Funding Bank ("MFB", "we", "us") respects the privacy of every person who visits our website or uses our services. This Privacy Policy describes how we collect, use, share and safeguard personal information.</p>
    <h3>Information we collect</h3>
    <p>We collect information you provide directly (name, email, phone, KYC documents) and information collected automatically (device, browser, IP, usage analytics).</p>
    <h3>How we use information</h3>
    <p>We use information to deliver our services, comply with regulatory obligations (including KYC/AML), prevent fraud, communicate updates and improve our products.</p>
    <h3>Sharing</h3>
    <p>We do not sell personal information. We share only with regulated service providers, custodians, exchanges, regulators and law-enforcement when legally required.</p>
    <h3>Security</h3>
    <p>We use bank-grade encryption (256-bit), multi-factor authentication and segregated custody to protect your data.</p>
    <h3>Your rights</h3>
    <p>You may request access, correction, deletion or portability of your data by writing to privacy@myfundingbank.com.</p>
    <h3>Updates</h3>
    <p>We may update this policy periodically. Material changes will be communicated by email or in-app notice.</p>
  </>
);

export default function PrivacyPage() {
  return (
    <article className="py-20" data-testid="privacy-page">
      <div className="mfb-container max-w-3xl">
        <div className="overline mb-3">Legal</div>
        <h1 className="font-[Outfit] text-5xl font-light tracking-tighter text-white">Privacy Policy</h1>
        <div className="mt-2 text-slate-500 text-sm">Effective: {new Date().toLocaleDateString()}</div>
        <div className="prose prose-invert prose-headings:font-[Outfit] prose-headings:font-light max-w-none mt-8 text-slate-300 leading-relaxed text-sm">
          {content}
        </div>
      </div>
    </article>
  );
}
